import { createStyles, keyframes } from '@mantine/core';

const rotate = keyframes`
  0% { --angle: -45deg }
  100% { --angle: 315deg }
`;

export const useStyles = createStyles(
  (theme, { primary, background }: { primary: string; background: string }) => ({
    skeleton: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 310,
      minHeight: 64,
      borderRadius: theme.radius.lg,
    },

    container: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      minHeight: 64,
      gap: theme.other.spacing._12,
      padding: `0 ${theme.other.spacing._16}px`,
      borderRadius: theme.radius.lg,
      border: `2px solid transparent`,
      minWidth: 310,
      cursor: 'pointer',

      '@property --angle': {
        syntax: '"<angle>"',
        initialValue: '-45deg',
        inherits: 'false',
      },

      background: theme.white,
      borderColor: background,

      '&.hasAnimation': {
        borderColor: 'transparent',

        // Black magic for the gradient border animation
        background: `linear-gradient(#FFFFFF, #FFFFFF) padding-box,
      conic-gradient(from var(--angle), #FFFFFF, ${background}, #FFFFFF) border-box`,
        animation: `${rotate} 3s ease-in-out infinite`,
        animationFillMode: 'forwards',
      },

      '&.isDark': {
        background,
        animation: 'none',
      },
    },

    textSection: {
      flex: '1 0 auto',
      display: 'flex',
      flexDirection: 'column' as const,
      position: 'relative',
    },
    title: {
      color: primary,
    },
    subtitle: {
      color: theme.colors.gray2[3],
    },
    progressBarContainer: {
      position: 'relative',
      height: 4,
      borderRadius: theme.radius.xs,
      backgroundColor: 'rgba(0, 0,0, 0.1)',
      width: 'calc(100% - 8px)',
      marginTop: theme.other.spacing._8,
    },
    progressBarFill: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      borderRadius: theme.radius.xs,
      backgroundColor: '#B86C59',
    },
    progressBarTooltip: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bottom: 14,
      right: -8,
      borderRadius: theme.radius.sm,
      padding: `${theme.other.spacing._4}px ${theme.other.spacing._6}px`,
      backgroundColor: '#B86C59',
      color: theme.white,

      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: -3,
        right: 6,
        width: 10,
        aspectRatio: '1/cos(60deg)',
        clipPath: 'polygon(50% 100%,100% 0,0 0)',
        background: '#B86C59',
      },
    },

    button: {
      flexShrink: 0,

      color: theme.colors.gray2[3],
    },

    pill: {
      display: 'flex',
      height: 18,
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '3px 6px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.other.spacing._8,
      borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
      color: theme.white,
      background,
    },
  })
);
